@if (assistant.enabled) {
  @if (!open) {
    <button type="button" class="as-launch" (click)="open = true" aria-label="Open the AI-Assistant" pTooltip="Ask the AI-Assistant" tooltipPosition="left">
      <span class="pi pi-comments"></span>
    </button>
  }
  @if (open) {
    <div class="as-panel" role="dialog" aria-label="AI-Assistant">
      <div class="as-head">
        <span class="pi pi-comments"></span>
        <span class="as-title">AI-Assistant</span>
        <span class="as-badge">Beta</span>
        <button type="button" class="as-icon" (click)="assistant.clear()" [disabled]="assistant.working" aria-label="Start again" title="Start again">
          <span class="pi pi-refresh"></span>
        </button>
        <button type="button" class="as-icon" (click)="open = false" aria-label="Close the AI-Assistant" title="Close">
          <span class="pi pi-times"></span>
        </button>
      </div>
      <div class="as-body" #scroller>
        @if (assistant.entries.length == 0) {
          <div class="as-intro">
            <div class="as-intro-text">Ask about your bookings, figures and packages. It looks things up, and any change it suggests waits for you to press Confirm.</div>
            @for (suggestion of suggestions; track suggestion) {
              <button type="button" class="as-suggestion" (click)="send(suggestion)">{{suggestion}}</button>
            }
          </div>
        }
        @for (entry of assistant.entries; track entry) {
          <!-- A change the assistant has proposed. Nothing happens until Confirm is pressed. -->
          @if (entry.action) {
            <div class="as-card" [ngClass]="'as-card--' + entry.action.status">
              <div class="as-card-title"><span class="pi" [ngClass]="entry.action.icon" style="margin-right:6px;"></span>{{entry.action.title}}</div>
              <div class="as-card-text">{{entry.action.summary}}</div>
              @if (entry.action.status == 'pending') {
                <div class="as-card-buttons">
                  <button type="button" class="as-btn as-btn--go" (click)="assistant.confirmAction(entry.action)">Confirm</button>
                  <button type="button" class="as-btn" (click)="assistant.cancelAction(entry.action)">Cancel</button>
                </div>
              }
              @if (entry.action.status == 'working') {
                <div class="as-card-note"><span class="pi pi-spin pi-spinner" style="margin-right:6px;"></span>{{entry.action.workingText}}</div>
              }
              @if (entry.action.status == 'done') {
                <div class="as-card-note as-card-note--done"><span class="pi pi-check" style="margin-right:6px;"></span>{{entry.action.message}}</div>
              }
              @if (entry.action.status == 'failed') {
                <div class="as-card-note as-card-note--failed"><span class="pi pi-times-circle" style="margin-right:6px;"></span>{{entry.action.message}}</div>
              }
              @if (entry.action.status == 'cancelled') {
                <div class="as-card-note">{{entry.action.message}}</div>
              }
              <!-- Telling the customer, once it has moved. -->
              @if (entry.action.status == 'done' && entry.action.hasEmail) {
                <div class="as-card-buttons">
                  @if (entry.action.email != 'sent') {
                    <button type="button" class="as-btn" [disabled]="entry.action.email == 'sending'" (click)="assistant.resendConfirmation(entry.action)">
                      <span class="pi" [ngClass]="entry.action.email == 'sending' ? 'pi-spin pi-spinner' : 'pi-envelope'" style="margin-right:6px;"></span>Resend confirmation email
                    </button>
                  }
                  @if (entry.action.email == 'sent') {
                    <span class="as-card-note as-card-note--done"><span class="pi pi-check" style="margin-right:6px;"></span>Confirmation email sent.</span>
                  }
                  @if (entry.action.email == 'failed') {
                    <span class="as-card-note as-card-note--failed">The email could not be sent.</span>
                  }
                </div>
              }
            </div>
          }
          @if (!entry.action) {
            <div class="as-entry" [ngClass]="'as-entry--' + entry.role">
              @if (entry.role == 'status') {
                <span class="pi pi-spin pi-spinner" style="margin-right:6px;"></span>
                }{{entry.text}}
              </div>
            }
          }
        </div>
        <div class="as-foot">
          <textarea [(ngModel)]="question" (keydown)="onKeydown($event)" rows="2" placeholder="Ask a question..." [disabled]="assistant.working" aria-label="Your question"></textarea>
          <button type="button" class="as-send" (click)="send()" [disabled]="assistant.working || question.trim() == ''" aria-label="Send">
            <span class="pi" [ngClass]="assistant.working ? 'pi-spin pi-spinner' : 'pi-send'"></span>
          </button>
        </div>
      </div>
    }
  }
